import React, {Component} from 'react'

import CRUDManagerGenerator from '../generators/CRUDGenerator'
import {
    checkPermission,
    TIMESHEETS_CAN_CREATE_UNBILLABLE_TYPES,
    TIMESHEETS_CAN_EDIT_UNBILLABLE_TYPES
} from "../../../lib/permissions";

const create = {
    table: 'unbillable_types',
    mutationType: 'upsert_',
    schema: {
        title: 'Create Unbillable Type',
        type: 'object',
        required: ['description', 'used_in_timesheet'],
        properties: {
            description: {type: 'string', title: 'Description'},
            used_in_timesheet: {
                title: 'Display on Timesheet',
                type: "number",
                enum: [1, 0],
                enumNames: ["True", "False"],
                default: 1
            }
        }
    }
}

const update = {
    table: 'unbillable_types',
    mutationType: 'upsert_',
    schema: {
        title: 'Update Unbillable Type',
        type: 'object',
        required: ['description', 'used_in_timesheet'],
        properties: {
            unbillable_type_id: {type: 'integer'},
            description: {type: 'string', title: 'Description'},
            used_in_timesheet: {
                title: 'Display on Timesheet',
                type: "number",
                enum: [1, 0],
                enumNames: ["True", "False"]
            }
        }
    },
    uiSchema: {
        unbillable_type_id: {"ui:widget": "hidden"},
    },
}

const read = {
    title: 'Unbillable Types',
    description: 'Unbillable types appear on staff timesheets as items which can have time assigned, which is not billable to a client.',
    table: 'unbillable_types',
    fields: ['unbillable_type_id', 'description', 'used_in_timesheet'],
    uniqueKey: 'unbillable_type_id',
    columns: [
        {Header: 'ID', accessor: 'unbillable_type_id', maxWidth: '100'},
        {Header: 'Desc', accessor: 'description'},
        {
            Header: 'Display on Timesheet',
            accessor: 'used_in_timesheet',
            maxWidth: '100',
            Cell: row => (
                <p className={'text-center' && (row.value) ? 'text-dark' : 'text-primary'}>{(row.value) ? 'True' : 'False'}</p>
            )
        }
    ]
}

const config = {
    create,
    read,
    update
}


const CRUDManager = CRUDManagerGenerator(config)

class UnbillableTypes extends Component {

    render() {
        return (
            <CRUDManager
                canCreate={checkPermission(TIMESHEETS_CAN_CREATE_UNBILLABLE_TYPES)}
                canEdit={checkPermission(TIMESHEETS_CAN_EDIT_UNBILLABLE_TYPES)}
            />
        )
    }
}

export default UnbillableTypes